import { render } from "./PatientResultHistory.vue?vue&type=template&id=9f9fdda4&scoped=true"
import script from "./PatientResultHistory.vue?vue&type=script&lang=js"
export * from "./PatientResultHistory.vue?vue&type=script&lang=js"

import "./PatientResultHistory.vue?vue&type=style&index=0&id=9f9fdda4&lang=scss&scoped=true"
import "./PatientResultHistory.vue?vue&type=style&index=1&id=9f9fdda4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9fdda4"],['__file',"src/components/cases/PatientResultHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f9fdda4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f9fdda4', __exports__)) {
    console.log('reload')
    api.reload('9f9fdda4', __exports__)
  }
  
  module.hot.accept("./PatientResultHistory.vue?vue&type=template&id=9f9fdda4&scoped=true", () => {
    console.log('re-render')
    api.rerender('9f9fdda4', render)
  })

}


export default __exports__